import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { Lancamento } from '../../../models/lancamento';
import { ConciliacaoService } from '../../../services/conciliacao.service';
import { ExibeCorrespondenciaDialogComponent } from '../../../../../../shared/dialogs/exibe-correspondencia-dialog/exibe-correspondencia-dialog.component';
import { OrigemLancamento } from '../../../../../../shared/models/enums/origem-lancamento';

export interface ListagemBuscaEmMassaDialogData {
  titulo: string;
  lancamentos: Lancamento[];
  origem: OrigemLancamento;
  // Presente apenas na lista de conciliados — habilita o botão "Ver correspondência" por linha.
  cardEhBanco?: boolean;
}

@Component({
  selector: 'app-listagem-busca-em-massa-dialog',
  standalone: false,
  templateUrl: './listagem-busca-em-massa-dialog.component.html',
  styleUrl: './listagem-busca-em-massa-dialog.component.scss'
})
export class ListagemBuscaEmMassaDialogComponent implements OnInit {

  lancamentosOrdenados: Lancamento[];
  protected tituloColunaLancamento: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ListagemBuscaEmMassaDialogData,
    private conciliacaoService: ConciliacaoService,
    private dialog: MatDialog,
  ) {
    this.lancamentosOrdenados = [...data.lancamentos].sort((a, b) =>
      new Date(a.data).getTime() - new Date(b.data).getTime() || a.valor - b.valor
    );
  }

  ngOnInit(): void {
    this.tituloColunaLancamento = this.data.origem === OrigemLancamento.Banco ? 'Lançamento' : 'Lote';
  }

  public verCorrespondenciaClick(lancamento: Lancamento): void {
    const correspondenciaIndex = this.conciliacaoService.getCorrespondenciaIndex(lancamento, this.data.cardEhBanco!);

    this.dialog.open(ExibeCorrespondenciaDialogComponent, {
      width: '1000px',
      maxWidth: '100vw',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      data: {
        acaoDesfazer: true,
        correspondenciaIndex,
      }
    });
  }
}
